import React, { useContext } from 'react';
import styled from 'styled-components'
import Price from './components/price'
import PaymentInfo from './components/billing-info/billing-info'
import PaymentHistory from './components/payment-history'
import Transaction from './components/transaction'
import { ThemeContext } from 'styled-components'
import { AuthContext } from '../../../../auth-context'

const Page = styled.div`
`

const Content = styled.div`
  margin: 0 auto;
  max-width: 1200px;
  padding: 32px 16px;

  @media(max-width: 900px) {
    padding: 16px 8px;
  }
`

const MarginSpacer = styled.div`
  height: 32px;
`

const Billing = () => {
  const theme = useContext(ThemeContext)
  const { user } = useContext(AuthContext)

  return (
    <Page>
      <Content>
        {theme.name === 'AVATAR' &&
          <>
            <Price />
            <MarginSpacer />
          </>
        }
        {user.payment_alert_date !== null && user.balance > 0 &&
          <>
            <Transaction />
            <MarginSpacer />
          </>
        }
        <PaymentInfo />
        {user.transactions.length !== 0 &&
          <React.Fragment>
            <MarginSpacer />
            <PaymentHistory />
          </React.Fragment>
        }
      </Content>
    </Page>
  )
}

export default Billing